import { useEffect, useState } from 'react';
import dayjs from 'dayjs';
import { useNavigate, useParams } from 'react-router-dom';
import { AnomalyService, IAnomaliasPut, IDetalhesAnomalia } from '../../../../../services/api/anomaly/AnomalyService';
import { LayoutBase } from '../../../../../layouts';
import { ToolsDetails } from '../../../../../components/custom';
import { ConfirmationDialog, CustomAlert, VMenu } from '../../../../../components/shared';
import { Box, Button, Card, Dialog, DialogContent, DialogTitle, Divider, FormControl, FormControlLabel, InputLabel, LinearProgress, MenuItem, Select, Switch, Table, TableBody, TableCell, TableHead, TableRow, TextField, Typography } from '@mui/material';
import { IActionPlanData, PlanosDeAcaoService } from '../../../../../services/api/planosDeAcao/PlanosDeAcaoService';
import { Controller, useForm } from 'react-hook-form';
import { Add, Cancel, Iron, Save } from '@mui/icons-material';
import { INewActivityFormData } from '../../../../../components/custom/ActionPlans/NewActivityForm';
import { ActionPlanActivitiesService } from '../../../../../services/api/planosDeAcao/ActionPlanActivitiesService';
import { VAutoCompletEmployer } from '../../../../../components/shared/VAutoCompletEmployer';
import { useAuthContext } from '../../../../../context';
import { useTheme } from '@mui/material/styles';
import { formatDateWhitoutHour } from '../../../../../services/helpers/helpers';

// const defaultValues: IActionPlanData = {
//     acao: '',
//     codigo_anomalia: '',
//     dataRelatorioInspecao: '',
//     descricao: '',
//     descricaoAnomalia: '',
//     id_anomalia: '',
//     npa: '',
//     data_limite_seguranca: '',
//     finalizado: false,
//     responsavel_principal: '',
//     uuid: ''
// };

interface Atividade {
    atualizado_em?: string;
    data_criacao: string;
    descricao_atividade: string;
    finalizado: boolean;
    id_barragem: string;
    id_plano: string;
    observacoes_gerais: string;
    prazo_previsto_final: string;
    prazo_previsto_inicio: string;
    prazo_real_final: string;
    prazo_real_inicio: string;
    responsavel_precedimento_nome: string;
    responsavel_procedimento: string;
    uuid: string;
    criado_por?: string;
}

function disableFunctionButtons(
    criado_por: string | undefined,
    data_criacao: string,
    user_uuid: string,
    finalizado: boolean,
): boolean {
    if (finalizado) return true;
    if (!data_criacao) return true;
    const dataCriacao = new Date(data_criacao.replace(' ', 'T'));
    const agora = new Date();

    const diffMs = agora.getTime() - dataCriacao.getTime();
    const diffHoras = diffMs / (1000 * 60 * 60);

    const passou72h = diffHoras > 72;

    if (criado_por) {
        if (criado_por !== user_uuid) return true;
        return passou72h;
    }
    return passou72h;
}

function verifyActivePlanButton(status: IActionPlanData['status'], finalizado: boolean | undefined) {
    if(status === 'NAO INICIADO' && finalizado === false){
        return false;
    }

    if(status === null && finalizado === false){
        return false;
    }

    return true;
}

export default function EditActionPlan() {

    const { id, plano } = useParams();
    const navigate = useNavigate();
    const { userData } = useAuthContext();

    const [alertInfo, setAlertInfo] = useState<{ open: boolean; message: string; severity: 'success' | 'error' | 'warning' | 'info' }>({
        open: false,
        message: '',
        severity: 'success',
    });
    const [open, setOpen] = useState<boolean>(false);
    const theme = useTheme();
    const [dataAnomalia, setDataAnomalia] = useState<IDetalhesAnomalia | null>(null);
    const [dataAtividades, setDataAtividades] = useState<Atividade[] | null>(null);

    const [loadingAnomalia, setLoadingAnomalia] = useState<boolean>(true);
    const [loadingAtividades, setLoadingAtividades] = useState<boolean>(true);
    const [loadingFinalize, setLoadinFinalize] = useState<boolean>(false);

    const [mode, setMode] = useState<'create' | 'edit'>('create');
    const [new_codigo, setNew_codigo] = useState<string>('');

    const [openConfirmPlanDeleteDialog, setOpenConfirmPlanDeleteDialog] = useState<boolean>(false);
    const [finalizaBloqued, setFinalizeBloqued] = useState<boolean>(false);

    const [openConfirmDeleteDialog, setOpenConfirmDeleteDialog] = useState<boolean>(false);
    const [uuidToDelet, setUuidToDelet] = useState<string>('');
    const [isFinalizing, setIsFinalizing] = useState<boolean>(false);

    const pagePermissions = userData.nivel_acesso?.acompanhamentos?.plano;

    type FormSchema = IActionPlanData;
    const { register, formState, reset, handleSubmit, getValues, control, setValue, watch } = useForm<FormSchema>();

    const teste = watch();
    useEffect(() => {
        console.log(teste);
    }, [teste]);

    type FormSchemaAtividade = INewActivityFormData;
    const {
        register: registerActivity,
        handleSubmit: handleSubmitActivity,
        formState: formStateActivity,
        reset: resetActivity,
        watch: watchActivity,
        setValue: setValueActivity,
    } = useForm<FormSchemaAtividade>();

    async function fetchData(uuid_plano: string) {
        setLoadingAnomalia(true);
        try {
            const res = await PlanosDeAcaoService.getById(uuid_plano);
            if (res instanceof Error) {
                setAlertInfo({ open: true, message: 'Erro ao buscar dados do plano de ação!', severity: 'warning' });
            }
            const data = res as IActionPlanData;
            data.data_limite_seguranca = data.data_limite_seguranca?.split(' ')[0];
            data.id_anomalia !== null && await fetchAnomalia(data.id_anomalia);
            await fetchAtividades();
            reset(data);
            setIsFinalizing(data.finalizado ? true : false);
            setLoadingAnomalia(false);
        } catch (error) {
            setAlertInfo({ open: true, message: 'Erro ao buscar dados do plano de ação!', severity: 'warning' });
        }
    }

    async function fetchAnomalia(uuid_anomalia: string) {
        try {
            const res = await AnomalyService.get(uuid_anomalia);
            if (res instanceof Error) {
                setAlertInfo({ open: true, message: 'Erro ao buscar dados da anomalia!', severity: 'warning' });
            }
            const data = res.detalhes as IDetalhesAnomalia;
            data.data_inspecao = data.data_inspecao.split(' ')[0];
            setDataAnomalia(data);
            setNew_codigo(data.codigo_anomalia ?? '');
            return data;
        } catch (error) {
            setAlertInfo({ open: true, message: 'Erro ao buscar dados da anomalia!', severity: 'warning' });
        }
    }

    async function fetchAtividades() {
        try {
            const res = await ActionPlanActivitiesService.getAll(plano ?? '');
            if (res instanceof Error) {
                setAlertInfo({ open: true, message: 'Erro ao buscar atividade!', severity: 'warning' });
            } else {
                setLoadingAtividades(false);
                setDataAtividades(res as Atividade[]);
            }
        } catch (error) {
            setAlertInfo({ open: true, message: 'Erro ao buscar atividade!', severity: 'warning' });
        }
    }

    useEffect(() => {
        plano && fetchData(plano);
    }, []);

    async function submitActivity(data: FormSchemaAtividade) {

        if (data.uuid) {
            try {
                const res = await ActionPlanActivitiesService.update(data.uuid, data);
                if (res instanceof Error) {
                    setAlertInfo({ open: true, message: 'Erro ao editar atividade!', severity: 'warning' });
                    return;
                }
                setAlertInfo({
                    open: true,
                    message: 'Atividade editada com sucesso!',
                    severity: 'success'
                });

                await fetchAtividades();
                resetActivity();
                setOpen(false);
            } catch (error) {
                setAlertInfo({
                    open: true,
                    message: 'Erro ao editar atividade!',
                    severity: 'error'
                });
            }
        } else {
            try {
                const res = await ActionPlanActivitiesService.create(getValues('uuid') ?? '', data);
                if (res instanceof Error) {
                    setAlertInfo({ open: true, message: 'Erro ao salvar atividade!', severity: 'warning' });
                    return;
                }
                setAlertInfo({
                    open: true,
                    message: 'Atividade cadastrada com sucesso!',
                    severity: 'success'
                });
                await fetchAtividades();
                resetActivity();
                setOpen(false);
            } catch (error) {
                setAlertInfo({
                    open: true,
                    message: 'Erro ao cadastrar atividade!',
                    severity: 'error'
                });
            }
        }
    }

    async function submitPlano(data: IActionPlanData) {
        try {
            if (data.codigo_anomalia !== new_codigo && new_codigo !== '' && data.id_anomalia !== null) {
                const dataSend = {
                    ...dataAnomalia,
                    codigo_anomalia: new_codigo
                };

                const resAnomalia = await AnomalyService.update(
                    dataSend as IAnomaliasPut,
                    dataSend.uuid ?? ''
                );

                if (resAnomalia instanceof Error) {
                    setAlertInfo({
                        open: true,
                        message: 'Erro ao atualizar anomalia!',
                        severity: 'warning'
                    });
                    return;
                }
            }
            // Atualiza plano de ação
            const dataSend = {
                ...data,
                status: data.finalizado === true ? 'FINALIZADO' : data.status,
            };
            
            const resPlano = await PlanosDeAcaoService.update(
                data.uuid ?? '',
                dataSend
            );            

            if (resPlano instanceof Error) {
                setAlertInfo({
                    open: true,
                    message: 'Erro ao atualizar!',
                    severity: 'warning'
                });
                return;
            }

            setAlertInfo({
                open: true,
                message: 'Plano de ação atualizado!',
                severity: 'success'
            });

            setTimeout(() => {
                navigate(-1);
            }, 1000);

        } catch (error) {
            setAlertInfo({
                open: true,
                message: 'Erro inesperado ao atualizar!',
                severity: 'warning'
            });
        }
    }



    // if (data.codigo_anomalia !== '' && data.codigo_anomalia !== cod_antigo) {

    //     const data_anomalia_send = dataAnomalia;
    //     // data_anomalia_send?.codigo_anomalia = getValues('codigo_anomalia');
    //     // const res_anomalia = AnomalyService.update(dataAnomalia?.uuid, dataAnomalia);

    //     try {
    //         const res = await PlanosDeAcaoService.update(data.uuid ?? '', data);
    //         if (res instanceof Error) {
    //             setAlertInfo({ open: true, message: 'Erro ao atualizar !', severity: 'warning' });
    //         }
    //         setAlertInfo({ open: true, message: 'Plano de ação atualizado !', severity: 'success' });
    //         setTimeout(() => {
    //             navigate(-1);
    //         }, 1000);

    //     } catch (error) {
    //         setAlertInfo({ open: true, message: 'Erro ao atualizar !', severity: 'warning' });
    //     }
    // }

    // try {
    //     const res = await PlanosDeAcaoService.update(data.uuid ?? '', data);
    //     if (res instanceof Error) {
    //         setAlertInfo({ open: true, message: 'Erro ao atualizar !', severity: 'warning' });
    //     }
    //     setAlertInfo({ open: true, message: 'Plano de ação atualizado !', severity: 'success' });
    //     setTimeout(() => {
    //         navigate(-1);
    //     }, 1000);

    // } catch (error) {
    //     setAlertInfo({ open: true, message: 'Erro ao atualizar !', severity: 'warning' });
    // }

    async function onFinalizeActivity(uuid_atividade: string) {
        setLoadinFinalize(true);
        try {
            const res = ActionPlanActivitiesService.finalize(plano ?? '', uuid_atividade);
            if (res instanceof Error) {
                setAlertInfo({ open: true, message: 'Erro ao finalizar atividade !', severity: 'warning' });
                setLoadinFinalize(false);
            }
            await fetchAtividades();
            setLoadinFinalize(false);
        } catch (error) {
            setLoadinFinalize(false);
            setAlertInfo({ open: true, message: 'Erro ao finalizar atividade !', severity: 'warning' });
        }
    }

    async function onDeletActivity() {
        resetActivity();
        try {
            const res = ActionPlanActivitiesService.delete(uuidToDelet);
            if (res instanceof Error) {
                setAlertInfo({ open: true, message: 'Erro ao deletar atividade !', severity: 'warning' });
                setOpenConfirmDeleteDialog(false);
            }
            fetchAtividades();
            setOpenConfirmDeleteDialog(false);
        } catch (error) {
            setAlertInfo({ open: true, message: 'Erro ao deletar atividade !', severity: 'warning' });
            setOpenConfirmDeleteDialog(false);
        }
    }

    async function editActivity(uuid_atividade: string) {
        setMode('edit');
        const atividade = dataAtividades?.filter((index) => index.uuid === uuid_atividade);
        if (atividade && atividade.length >= 1) {
            const edit: INewActivityFormData = {
                descricaoAtividade: atividade[0].descricao_atividade,
                observacoesGerais: atividade[0].observacoes_gerais,
                prazoPrevistoFim: atividade[0].prazo_previsto_final,
                prazoPrevistoInicio: atividade[0].prazo_previsto_inicio,
                prazoRealFim: atividade[0].prazo_real_final,
                prazoRealInicio: atividade[0].prazo_real_inicio,
                responsavelNomeDisplay: atividade[0].responsavel_procedimento,
                responsavelUuid: atividade[0].responsavel_procedimento,
                uuid: uuid_atividade,
            };
            resetActivity(edit);
            setOpen(true);
        }
    }

    function createActivity() {
        setMode('create');
        resetActivity({
            descricaoAtividade: '',
            observacoesGerais: '',
            prazoPrevistoInicio: '',
            prazoPrevistoFim: '',
            prazoRealInicio: '',
            prazoRealFim: '',
            responsavelUuid: '',
            uuid: undefined,
        });
        setOpen(true);
    }

    async function onDeletePlan() {
        resetActivity();
        try {
            const res = PlanosDeAcaoService.delete(plano ?? '');
            if (res instanceof Error) {
                setAlertInfo({ open: true, message: 'Erro ao deletar atividade !', severity: 'warning' });
                setLoadinFinalize(false);
            }
            navigate(-1);
            await fetchAtividades();
        } catch (error) {
            setAlertInfo({ open: true, message: 'Erro ao deletar atividade !', severity: 'warning' });
        }
    }

    function OpenPopup() {
        resetActivity(undefined);
        setOpen(prev => !prev);
    }

    function OpenDeletActivity(uuid_atividade: string) {
        setUuidToDelet(uuid_atividade);
        setOpenConfirmDeleteDialog(true);
    }

    function verifyFinalize() {
        const hasActivityOpen = dataAtividades?.some((item) => item.finalizado == false) || dataAtividades?.length === 0;
        hasActivityOpen != undefined && setFinalizeBloqued(hasActivityOpen);
    }

    useEffect(() => {
        verifyFinalize();
    }, [dataAtividades]);

    return (
        <LayoutBase
            title='Cadastro de plano de ação'
            tollBar={
                <ToolsDetails
                    onClickSave={handleSubmit(submitPlano)}
                    onClickDelet={() => setOpenConfirmPlanDeleteDialog(true)}
                    showNewButton={false}
                    showSaveButton={!isFinalizing}
                    disableSave={!pagePermissions?.includes('add') || !pagePermissions.includes('edit')}
                />
            }
        >
            <VMenu id={id} />
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 5 }}>
                {loadingAnomalia && (
                    <Box sx={{ padding: 2, margin: 2 }}>
                        <LinearProgress />
                    </Box>
                )}

                {!loadingAnomalia && (
                    <Card sx={{ boder: '2px #ccc solid', borderRadius: 3, padding: 2 }}>
                        <form id='plano'>
                            <Box sx={{ display: 'grid', gridTemplateColumns: 'auto auto', gap: 2 }}>
                                <Box sx={{ gridColumn: 'span 2' }}>
                                    <Typography variant='h5'>Cadastrar plano de ação</Typography>
                                    <Divider />
                                </Box>
                                <TextField
                                    value={dataAnomalia?.item}
                                    label='Localização da anomalia'
                                    fullWidth
                                    disabled
                                    InputLabelProps={{ shrink: true }}
                                    sx={{ bgcolor: '#cccccc21' }}
                                />
                                <TextField
                                    value={dataAnomalia?.data_inspecao}
                                    label='Data de inspeção'
                                    type='date'
                                    disabled
                                    InputLabelProps={{ shrink: true }}
                                    sx={{ bgcolor: '#cccccc21' }}
                                />
                                <TextField
                                    value={dataAnomalia?.observacoes_gerais}
                                    label='Descrição da anomalia'
                                    fullWidth
                                    multiline
                                    rows={2}
                                    disabled
                                    InputLabelProps={{ shrink: true }}
                                    sx={{ bgcolor: '#cccccc21' }}
                                />
                                <Box sx={{ display: 'grid', gridTemplateColumns: 'auto auto', gap: 2 }}>
                                    <TextField
                                        label='Código de identificação da anomalia'
                                        // disabled
                                        helperText='Código gerado ao criar anomalia'
                                        InputLabelProps={{ shrink: true }}
                                        value={new_codigo}
                                        sx={{ color: '#cccccc21' }}
                                        onChange={e => setNew_codigo(e.target.value)}
                                    />
                                    <TextField
                                        label='Código de identificação da anomalia (antigo)'
                                        InputLabelProps={{ shrink: true }}
                                        disabled
                                        // sx={{ color: '#cccccc21' }}
                                        {...register('codigo_anomalia', { required: false })}
                                    />
                                </Box>
                                <TextField
                                    label='Data limite de segurança'
                                    fullWidth
                                    InputLabelProps={{ shrink: true }}
                                    type='date'
                                    error={!!formState.errors.data_limite_seguranca}
                                    helperText={formState.errors.data_limite_seguranca && 'Campo obrigatório'}
                                    {...register('data_limite_seguranca', { required: true })}
                                />
                                <FormControl fullWidth error={!!formState.errors.acao}>
                                    <InputLabel>Natureza da Ação</InputLabel>

                                    <Controller
                                        name="acao"
                                        control={control}
                                        defaultValue=""
                                        rules={{ required: true }}
                                        render={({ field }) => (
                                            <Select {...field} label="Ação">
                                                <MenuItem value="MC - Monitoramento/Controle">MC - Monitoramento/Controle</MenuItem>
                                                <MenuItem value="CL - Conservação/Limpeza">CL - Conservação/Limpeza</MenuItem>
                                                <MenuItem value="PJ - Projetos de Engenharia">PJ - Projetos de Engenharia</MenuItem>
                                                <MenuItem value="SE - Serviço de engenharia">SE - Serviço de engenharia</MenuItem>
                                                <MenuItem value="ES - Engenharia especializada">ES - Engenharia especializada</MenuItem>
                                                <MenuItem value="EL - Eletromecânica">EL - Eletromecânica</MenuItem>
                                            </Select>
                                        )}
                                    />
                                </FormControl>
                                {/* <TextField
                                    label='Ação'
                                    fullWidth
                                    InputLabelProps={{ shrink: true }}
                                    error={!!formState.errors.acao}
                                    helperText={formState.errors.acao && 'Campo obrigatório'}
                                    {...register('acao', { required: true })}
                                /> */}
                                <TextField
                                    label='Responsável técnico'
                                    fullWidth
                                    InputLabelProps={{ shrink: true }}
                                    error={!!formState.errors.responsavel_principal}
                                    helperText={formState.errors.responsavel_principal && 'Campo obrigatório'}
                                    {...register('responsavel_principal', { required: true })}
                                />
                                <TextField
                                    label='Status'
                                    fullWidth
                                    InputLabelProps={{ shrink: true }}
                                    value={PlanosDeAcaoService.mapperStatus(getValues('status'))}
                                    disabled
                                />
                                <TextField
                                    label='Observação do plano de ação'
                                    fullWidth
                                    multiline
                                    rows={2}
                                    sx={{ gridColumn: 'span 2' }}
                                    InputLabelProps={{ shrink: true }}
                                    {...register('descricao', { required: false })}
                                />
                                <Button 
                                    variant='contained'
                                    disabled={verifyActivePlanButton(getValues('status'), getValues('finalizado'))}
                                    onClick={() => setValue('status', 'EM ANDAMENTO')}
                                >
                                    Ativar plano de ação
                                </Button>
                                <Controller
                                    name="finalizado"
                                    control={control}
                                    defaultValue={false}
                                    render={({ field }) => (
                                        <FormControlLabel
                                            label="Finalizado"
                                            control={
                                                <Switch
                                                    disabled={finalizaBloqued}
                                                    checked={field.value}
                                                    onChange={(e) => field.onChange(e.target.checked)}
                                                />
                                            }
                                        />
                                    )}
                                />
                            </Box>
                        </form>
                    </Card>
                )}

                {loadingAtividades && (
                    <Box sx={{ padding: 2, margin: 2 }}>
                        <LinearProgress />
                    </Box>
                )}

                {!loadingAtividades && (
                    <Card sx={{ boder: '2px #ccc solid', borderRadius: 3, padding: 2 }}>
                        <Box>
                            <Box sx={{ display: 'flex', justifyContent: 'space-between', marginBottom: 1 }}>
                                <Typography variant='h5'>Atividades do plano atual</Typography>
                                <Button variant='outlined' startIcon={<Add />} onClick={createActivity} disabled={getValues('finalizado') == true}>Nova atividade</Button>
                            </Box>
                            <Divider />
                            <Table sx={{ marginTop: 1 }}>
                                <TableHead>
                                    <TableRow>
                                        <TableCell>Descrição das Atividades/Ações</TableCell>
                                        <TableCell>Responsável(is) por Procedimento</TableCell>
                                        <TableCell>Prazo planejado (Início)</TableCell>
                                        <TableCell>Prazo planejado (Fim)</TableCell>
                                        <TableCell>Prazo real (Início)</TableCell>
                                        <TableCell>Prazo real (Fim)</TableCell>
                                        <TableCell>Observações Gerais</TableCell>
                                        <TableCell>Ações</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {dataAtividades && dataAtividades.length === 0 && (
                                        <TableRow>
                                            <TableCell colSpan={10} align="center">
                                                <Typography variant="subtitle1" color="textSecondary">
                                                    Nenhuma atividade cadastrada para este plano.
                                                </Typography>
                                            </TableCell>
                                        </TableRow>
                                    )}
                                    {dataAtividades && dataAtividades.length > 0 && dataAtividades?.map((item, index) => (
                                        <TableRow key={index}>
                                            <TableCell>{item.descricao_atividade}</TableCell>
                                            <TableCell>{item.responsavel_precedimento_nome}</TableCell>
                                            <TableCell>{formatDateWhitoutHour(item.prazo_previsto_inicio)}</TableCell>
                                            <TableCell>{formatDateWhitoutHour(item.prazo_previsto_final)}</TableCell>
                                            <TableCell>{formatDateWhitoutHour(item.prazo_real_inicio)}</TableCell>
                                            <TableCell>{formatDateWhitoutHour(item.prazo_real_final)}</TableCell>
                                            <TableCell>{item.observacoes_gerais}</TableCell>
                                            <TableCell align="center">
                                                <Box sx={{ display: 'flex', gap: 1, justifyContent: 'center' }}>
                                                    {/* Botão de Finalizar */}
                                                    {pagePermissions?.includes('add') && (
                                                        !item.finalizado ? (
                                                            <Button
                                                                variant="contained"
                                                                color="success"
                                                                size="small"
                                                                onClick={() => onFinalizeActivity(item.uuid)}
                                                                disabled={loadingFinalize}
                                                            >
                                                                Finalizar
                                                            </Button>
                                                        ) : (
                                                            <Typography
                                                                variant="body2"
                                                                sx={{ color: theme.palette.text.disabled }}
                                                            >
                                                                Finalizada
                                                            </Typography>
                                                        )
                                                    )}
                                                    {pagePermissions?.includes('edit') && (
                                                        <Button
                                                            variant="outlined"
                                                            color="info"
                                                            size="small"
                                                            onClick={() => editActivity(item.uuid)}
                                                            disabled={disableFunctionButtons(item.criado_por, item.data_criacao, userData.uuid ?? '', item.finalizado )}
                                                        >
                                                            Editar
                                                        </Button>
                                                    )}
                                                    {pagePermissions?.includes('remove') && (
                                                        <Button
                                                            variant="outlined"
                                                            color="error"
                                                            size="small"
                                                            onClick={() => OpenDeletActivity(item.uuid)}
                                                            disabled={disableFunctionButtons(item.criado_por, item.data_criacao, userData.uuid ?? '', item.finalizado )}
                                                        >
                                                            Excluir
                                                        </Button>
                                                    )}
                                                </Box>
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </Box>
                    </Card>
                )}
            </Box>
            {alertInfo.open &&
                <CustomAlert
                    message={alertInfo.message}
                    severity={alertInfo.severity}
                    key={alertInfo.message}
                />
            }
            <Dialog open={open} fullWidth>
                <DialogTitle>Cadastro de atividade</DialogTitle>
                <DialogContent>
                    <form id='atividade' onSubmit={handleSubmitActivity(submitActivity)}>
                        <Box sx={{ display: 'grid', gridTemplateColumns: 'auto auto', gap: 2, padding: 1 }}>
                            <TextField
                                label='Descrição das ativadades/ações'
                                fullWidth
                                multiline
                                rows={2}
                                InputLabelProps={{ shrink: true }}
                                sx={{ gridColumn: 'span 2' }}
                                error={!!formStateActivity.errors.descricaoAtividade}
                                helperText={formStateActivity.errors.descricaoAtividade && 'Campo obrigatório'}
                                {...registerActivity('descricaoAtividade', { required: true })}
                            />
                            <Box sx={{ gridColumn: 'span 2' }}>
                                <VAutoCompletEmployer
                                    uuidCompany={userData.id_empresa || ''}
                                    onUserChange={(uuid) => setValueActivity('responsavelUuid', uuid)}
                                    error={!!formStateActivity.errors.responsavelUuid}
                                    value={watchActivity('responsavelUuid')}
                                    label='Responsável'
                                />
                            </Box>
                            <TextField
                                label='Prazo planejado (Início)'
                                fullWidth
                                type='date'
                                disabled={mode == 'edit'}
                                InputLabelProps={{ shrink: true }}
                                inputProps={{ min: dayjs().format('YYYY-MM-DD') }}
                                error={!!formStateActivity.errors.prazoPrevistoInicio}
                                helperText={
                                    formStateActivity.errors.prazoPrevistoInicio?.message
                                    ?? (formStateActivity.errors.prazoPrevistoInicio && 'Campo obrigatório')
                                }
                                {...registerActivity('prazoPrevistoInicio', {
                                    required: true,
                                    validate: (value: string) => {
                                        if (!value) return true;
                                        return value >= dayjs().format('YYYY-MM-DD') || 'A data não pode ser anterior à data atual.';
                                    },
                                })}
                            />
                            <TextField
                                label='Prazo planejado (Fim)'
                                fullWidth
                                type='date'
                                disabled={mode == 'edit'}
                                InputLabelProps={{ shrink: true }}
                                error={!!formStateActivity.errors.prazoPrevistoFim}
                                helperText={formStateActivity.errors.prazoPrevistoFim && 'Campo obrigatório'}
                                {...registerActivity('prazoPrevistoFim', { required: true })}
                            />
                            <TextField
                                label='Prazo real (Início)'
                                fullWidth
                                type='date'
                                InputLabelProps={{ shrink: true }}
                                error={!!formStateActivity.errors.prazoRealInicio}
                                helperText={formStateActivity.errors.prazoRealInicio && 'Campo obrigatório'}
                                {...registerActivity('prazoRealInicio', { required: false })}
                            />
                            <TextField
                                label='Prazo real (Fim)'
                                fullWidth
                                type='date'
                                InputLabelProps={{ shrink: true }}
                                error={!!formStateActivity.errors.prazoRealFim}
                                helperText={formStateActivity.errors.prazoRealFim && 'Campo obrigatório'}
                                {...registerActivity('prazoRealFim', { required: false })}
                            />
                            <TextField
                                label='Observações gerais'
                                fullWidth
                                multiline
                                rows={2}
                                InputLabelProps={{ shrink: true }}
                                sx={{ gridColumn: 'span 2' }}
                                error={!!formStateActivity.errors.observacoesGerais}
                                helperText={formStateActivity.errors.observacoesGerais && 'Campo obrigatório'}
                                {...registerActivity('observacoesGerais', { required: false })}
                            />
                            <Button startIcon={<Cancel />} sx={{ color: 'red', ':hover': { bgcolor: '#ff00000c' } }} onClick={OpenPopup}>Cancelar</Button>
                            <Button type='submit' startIcon={<Save />}>Salvar atividade</Button>
                        </Box>
                    </form>
                </DialogContent>
            </Dialog>

            <ConfirmationDialog
                isOpen={openConfirmDeleteDialog}
                onClose={() => setOpenConfirmDeleteDialog(false)}
                onConfirm={onDeletActivity}
                title="Confirmar Exclusão de Atividade"
                message="Tem certeza que deseja excluir esta atividade? Esta ação não pode ser desfeita."
            />

            <ConfirmationDialog
                isOpen={openConfirmPlanDeleteDialog}
                onClose={() => setOpenConfirmPlanDeleteDialog(false)}
                onConfirm={onDeletePlan}
                title="Confirmar Exclusão de Plano de Ação"
                message="Tem certeza que deseja excluir este plano de ação e todas as suas atividades? Esta ação não pode ser desfeita."
            />
        </LayoutBase>
    );
}